import {useMemo} from 'react';

import {
  makeVariableSlugFromCustomField,
  resourceTypeToRootField,
} from '../../../../helpers/customFieldHelpers';
import {CustomFieldResourceTypesEnum} from '../../../../models/api/customFieldModel';
import {useSettingsCustomFields} from '../../../../settings/customFields/useCustomFields';
import {interpolationResourceTypes} from '../../../../store/data/customFields/customFieldsSelectors';

export function useComposerCustomFieldVariables() {
  const {customFields} = useSettingsCustomFields();

  return useMemo(
    () =>
      interpolationResourceTypes.flatMap((type) => {
        // TODO: Backfill templates and remove this.
        if (type === CustomFieldResourceTypesEnum.CARD) {
          return [
            ...customFields[type].map(makeVariableSlugFromCustomField),
            ...customFields[type].map(
              (customField) => `${resourceTypeToRootField(customField.resourceType)}.${customField.nameSlug}`,
            ),
          ];
        }

        return customFields[type].map(makeVariableSlugFromCustomField);
      }),
    [customFields],
  );
}
